const ArrowDown = (props) => (
  <svg width={49} height={49} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m23.787 22.565 7.935 7.935 2.13-2.115-7.95-7.935a3 3 0 0 0-4.23 0l-7.95 7.935 2.13 2.115 7.935-7.935z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export default ArrowDown;
